module.exports = __webpack_public_path__ + "static/screenshot3-ae915a28f1d41b9c7533480258f02d68.png";